export default __webpack_public_path__ + "static/media/20140928_163355.1e1de4a0-min.e8716926.jpg";